import { render, staticRenderFns } from "./ContactInformationSection.vue?vue&type=template&id=04362498&"
import script from "./ContactInformationSection.vue?vue&type=script&lang=js&"
export * from "./ContactInformationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports